/**
 * Extract YouTube video ID from a URL or bare ID.
 * @param {string} input - Full YouTube URL (any common format) or an 11-character video ID
 * @returns {string|null} The video ID, or null if none found
 */
export function getYouTubeVideoId(input) {
  if (!input || typeof input !== 'string') return null;
  const trimmed = input.trim();
  if (!trimmed) return null;

  // Bare ID: 11 chars, typical YouTube ID pattern (alphanumeric, -, _)
  if (/^[\w-]{11}$/.test(trimmed)) return trimmed;

  try {
    // youtu.be/ID
    const shortMatch = trimmed.match(/(?:youtu\.be\/)([\w-]{11})/);
    if (shortMatch) return shortMatch[1].split('&')[0];

    // youtube.com/watch?v=ID or youtube.com/embed/ID
    const url = new URL(trimmed.startsWith('http') ? trimmed : `https://${trimmed}`);
    if (url.hostname === 'www.youtube.com' || url.hostname === 'youtube.com') {
      const v = url.searchParams.get('v');
      if (v) return v.split('&')[0];
      const embedMatch = url.pathname.match(/\/embed\/([\w-]{11})/);
      if (embedMatch) return embedMatch[1].split('&')[0];
    }
    if (url.hostname === 'youtu.be') return url.pathname.slice(1).split('&')[0].split('/')[0];
  } catch (_) {
    return null;
  }
  return null;
}
